<template>
  <div>
    <v-card border>
      <b-section-loader :loading="$loading.isLoading('init')">
        <v-card-text>
          <div class="d-flex align-center justify-space-between ga-3 mb-3">
            <div class="d-flex align-center ga-3">
              <div class="icon--blue">
                <v-icon icon="mdi-file-document-outline" size="23"></v-icon>
              </div>

              <div>
                <div class="font-weight-bold font-size-18">
                  {{ documentSource.definition?.name }}
                  {{ documentSource.docTypeClass.name }}
                </div>
                <div class="d-flex align-center ga-3">
                  <span class="text-disabled">
                    <span v-if="activeVersion" class="text-disabled">
                      Версія {{ activeVersion.version }} |
                    </span>
                    {{ new CustomDate(documentSource.created_at).toString() }}
                  </span>
                  <v-chip
                    :color="getStatusColor(documentSource.status)"
                    rounded="pill"
                    density="compact">
                    <b>{{
                      keyToLabel(documentSource.status, 'documentStatus')
                    }}</b>
                  </v-chip>
                  <v-menu open-on-hover>
                    <template #activator="{ props }">
                      <v-btn
                        rounded="circle"
                        variant="tonal"
                        icon="mdi-account-multiple-outline"
                        color="deep-purple"
                        size="small"
                        density="compact"
                        v-bind="props"></v-btn>
                    </template>

                    <v-card>
                      <v-card-text>
                        <div class="font-weight-bold mb-1 font-size-15">
                          Розглядаючі:
                        </div>
                        <div v-if="!reviewList.length" class="text-disabled">
                          Розглядаючі відсутні
                        </div>
                        <div
                          v-for="(review, idx) in reviewList"
                          :key="review.id">
                          <div class="d-flex ga-1 align-center">
                            <span>
                              {{ getPersonName(review.reviewer) }}
                            </span>
                            <span>
                              {{ review.reviewer.post }}
                            </span>
                          </div>

                          <v-divider
                            v-if="idx < reviewList.length - 1"
                            class="my-2"></v-divider>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-menu>
                </div>
              </div>
            </div>
            <div class="d-flex align-center ga-2">
              <v-btn
                border
                density="comfortable"
                icon
                variant="flat"
                color="white">
                <v-icon
                  icon="mdi-tray-arrow-down"
                  color="grey-darken-3"></v-icon>
              </v-btn>
              <v-btn
                border
                density="comfortable"
                icon
                variant="flat"
                color="white">
                <v-icon
                  icon="mdi-printer-outline"
                  color="grey-darken-3"></v-icon>
              </v-btn>
              <b-action-menu v-if="actions.length" :actions="actions">
                <template #activator="{ props }">
                  <v-btn v-bind="props" density="default">
                    <v-icon icon="mdi-dots-horizontal" class="mr-2"></v-icon>
                    <span>Дії</span>
                  </v-btn>
                </template>
              </b-action-menu>
            </div>
          </div>

          <tabs class="mb-5"></tabs>

          <router-view></router-view>
        </v-card-text>
      </b-section-loader>
    </v-card>
  </div>
</template>

<script lang="ts" setup>
import Tabs from './components/Tabs.vue'
import { BActionMenu, BSectionLoader } from 'best-modules/components'
import { getStatusColor } from '@/pages/document/helpers'
import { CustomDate, getPersonName } from 'best-modules/utils'
import { keyToLabel } from '@/utils/key-to-label'
import { useBreadcrumb } from '@/plugins'
import { initDocument } from '@/pages/document/single/document'
import { computed } from 'vue'
import { handleAsync } from 'best-modules/plugins'
import { useRouter } from 'vue-router'

defineOptions({
  name: 'DocumentSingle',
})

const router = useRouter()
const breadcrumb = useBreadcrumb()
const {
  documentSource,
  activeVersion,
  getDocument,
  getMyReview,
  getResolutionList,
  getVersionList,
  returnFromReview,
  changeReviewer,
  sendToReview,
  hasActiveReviewers,
  myReview,
  reviewList,
} = initDocument()

const actions = computed(() => {
  if (documentSource.status !== 'under_review') return []

  if (!hasActiveReviewers.value) {
    return [
      {
        title: 'Призначити розглядаючих',
        action: () => sendToReview(),
      },
    ]
  }

  if (!myReview.value) return []

  return [
    {
      title: 'Змінити розглядаючого',
      icon: 'mdi-restore',
      action: () =>
        changeReviewer(() => router.push({ name: 'document-list-me' })),
    },
    {
      title: 'Повернути з розгляду',
      iconProps: { color: 'error' },
      icon: 'mdi-arrow-left-top',
      action: () => returnFromReview(),
    },
  ]
})

handleAsync('init', async () => {
  await getDocument()
  await getVersionList()
  await getMyReview()
  await getResolutionList()

  breadcrumb.set([
    {
      index: 0,
      title: 'Мені на розгляд',
      to: { name: 'document-list-review' },
    },
    {
      index: 1,
      title: `${documentSource.docTypeClass.name} ${documentSource.definition.name}`,
      disabled: true,
    },
  ])
})
</script>

<style scoped lang="scss"></style>
